import React, { Component } from "react";
import { Col, Image } from "react-bootstrap";

class Project extends Component {
    render() {
        const query = new URLSearchParams(this.props.data);
        query.delete('attachments');
        let project_url = "/project-detail/" + this.props.data.id  + "?" + query.toString();

        const project_image = (this.props.data.attachments) && !this.props.data.attachments.includes("default.jpg")?
            this.props.data.attachments :
            process.env.REACT_APP_BASE_URL + "/images/default/project.jpg";

        return (
            <Col md={6} className="items web info-overlay mb-50">
                <div className="item-img o-hidden">
                    <a href={project_url} className="imago wow">
                        <div className="inner wow">
                            <Image src={project_image} alt="image"/>
                        </div>
                    </a>
                    <div className="info">
                        <h5><a href={project_url}>{this.props.data.title}</a></h5>
                    </div>
                </div>
            </Col>
        );
    }
}

export default Project;
